<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex">
          <date-picker
            class="mr-2"
            v-model="filter.date"
            type="date" range
            value-type="format"
            format="DD.MM.YYYY"
            @change="() => {}"
            :shortcuts="shortcuts"
            placeholder="Выберите дату"/>
          <div class="mr-2">
            <select v-model="filter.division" class="form-control">
              <option value="0" disabled>Выберите дивизион</option>
              <option v-for="div in $AllDivisions" :value="div.id">{{ div.title }}</option>
            </select>
          </div>
          <div class="flex-grow-1 justify-content-end flex">
            <button @click="tableToCSV" class="btn btn-outline-info mr-1">экспортировать с CSV</button>
            <LoadingButton
              title="Поиск"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => getRecords()"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
    <div class="card" v-if="!loading && records?.length">
      <div class="card-body">
        <table class="table table-sm table-hover mt-1">
          <thead>
          <tr>
            <th>#</th>
            <th>ID</th>
            <th>Адрес</th>
            <th>Препараты</th>
            <th>Дата</th>
            <th>Сумма</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(o, i) in records" :key="i">
            <td>{{ i + 1 }}</td>
            <td>
              <p>{{ o.id }}</p>
              <p>{{ o.project_label }}</p>
            </td>
            <td>
              <p>{{ o.address }}</p>
            </td>
            <td>
              <p v-for="d in o.details">{{ d.drug.title }} x {{ d.qty }} x {{ d.price }}</p>
            </td>
            <td>{{ printDate(o.report_date) }}</td>
            <td>{{ o.price }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import VueHtmlToPaper from '@/components/print/htmlToPrint.js';
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import moment from 'moment'

export default {
  components: {
    DatePicker,
    VueHtmlToPaper,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      filter: {
        date: null,
        division: 0
      },
      records: null,
      shortcuts: [
        {
          text: 'Тек. месяц',
          onClick() {
            const startOfMonth = moment().clone().startOf('month').format('YYYY-MM-DD');
            const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
            return [new Date(startOfMonth), new Date(endOfMonth)];
          },
        },
        {
          text: 'Пр. месяц',
          onClick() {
            const startOfMonth = moment().clone().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
            const endOfMonth = moment(startOfMonth).clone().endOf('month').format('YYYY-MM-DD');
            return [new Date(startOfMonth), new Date(endOfMonth)];
          },
        },
        {
          text: 'За 3 месяца',
          onClick() {
            const startOfMonth = moment().clone().startOf('month').subtract(2, 'month').format('YYYY-MM-DD');
            const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
            return [new Date(startOfMonth), new Date(endOfMonth)];
          },
        },
        {
          text: 'За 6 мес.',
          onClick() {
            const startOfMonth = moment().clone().startOf('month').subtract(5, 'month').format('YYYY-MM-DD');
            const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
            return [new Date(startOfMonth), new Date(endOfMonth)];
          },
        },
        {
          text: 'За год',
          onClick() {
            const startOfMonth = moment().clone().startOf('month').subtract(12, 'month').format('YYYY-MM-DD');
            const endOfMonth = moment().clone().endOf('month').format('YYYY-MM-DD');
            return [new Date(startOfMonth), new Date(endOfMonth)];
          },
        },
      ],
    }
  },
  methods: {
    tableToCSV() {
      let csv_data = [];
      const rows = document.getElementsByTagName('tr');
      for (let i = 0; i < rows.length; i++) {
        const cols = rows[i].querySelectorAll('td,th');
        const csvrow = [];
        for (let j = 0; j < cols.length; j++) {
          // csvrow.push(cols[j].innerHTML);
          csvrow.push(cols[j].textContent);
        }
        csv_data.push(csvrow.join(";"));
      }
      csv_data = csv_data.join('\n');
      this.downloadCSVFile(csv_data);
    },
    downloadCSVFile(csv_data) {
      const CSVFile = new Blob([csv_data], {
        type: "text/csv"
      });
      const temp_link = document.createElement('a');
      temp_link.download = "export.csv";
      const url = window.URL.createObjectURL(CSVFile);
      temp_link.href = url;
      temp_link.style.display = "none";
      document.body.appendChild(temp_link);
      temp_link.click();
      document.body.removeChild(temp_link);
    },
    async getRecords() {
      this.loading = true;
      this.records = null;
      const {data} = await api.post('/statistics/detailedOrders', {
        filter: this.filter
      });
      if (data.success) {
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
